import { getParamsFromObject } from 'helper/helper';
import Routes from 'router/routes';
import DV from 'variables/DV';
import { ALL_PERMISSION, PERMISSION_NAME } from 'variables/staticValue';

// Owner/manager always can open the integrate screen, other staff only when the company enables MCP.
// The route is allowed by role, so this runtime check has to be applied wherever a landing page is picked.
export const canAccessIntegrateAPI = () =>
  checkPermission([PERMISSION_NAME.owner, PERMISSION_NAME.manager], DV.permission) ||
  !!DV.companySettings?.mcp?.active;

export const getListAllowRoutes = (listRoutes = Routes) => {
  let routes = [];
  for (let key in listRoutes) {
    if (!['company', 'login', 'joinCompany'].includes(key)) {
      const route = listRoutes[key];
      if (!!route.permission && checkPermission(route.permission, DV.permission))
        routes.push(route);
    }
  }

  return routes;
};

export const checkPermission = (required = [], user = []) => {
  if (DV.isOwner) return true;
  if (user.length === 0 && required.length === 0) return true;
  if (user.length === 0 && required.length === ALL_PERMISSION.length) return true;
  return required.some((r) => user.some((i) => i === r));
};

export const getNextPath = (url = '') => {
  // Skip the integrate screen when the user can't open it, it redirects back here and would loop forever.
  const routesPathArray = getListAllowRoutes().filter(
    (route) => route.path !== Routes.integrateAPI.path || canAccessIntegrateAPI(),
  );

  let pathName = routesPathArray[0].path;
  let index = routesPathArray.findIndex((item) => url && url.includes(item.path));
  if (index >= 0) {
    const nextPath = routesPathArray[index].path;
    if (
      nextPath !== Routes.company.path &&
      nextPath !== Routes.joinCompany.path &&
      nextPath !== Routes.empty.path &&
      nextPath !== Routes.login.path
    )
      pathName = nextPath;
  }
  const params = getParamsFromObject(DV.params);
  if (url.includes(pathName)) {
    if (params) return url + params;
    else return url;
  }

  return pathName;
};
